import { Box, Container, SimpleGrid } from '@chakra-ui/react'
import { Stat } from './Stat'

const stats = [
  { label: 'Total Cardholders', value: '71,887', delta: { value: '320', isUpwardsTrend: true } },
  { label: 'Avg. TXN Approval Rate', value: '56.87%', delta: { value: '2.3%', isUpwardsTrend: false } },
  { label: 'Total ATM in Service', value: '09', delta: { value: '02', isUpwardsTrend: true } },
  { label: 'Avg. Volume of TXN/CARD', value: '56.87%', delta: { value: '2.3%', isUpwardsTrend: true } },
]

export const BasicStatistics = () => (
  <Box as="section" py={{ base: '4', md: '8' }}>
    <Container maxW="full" mx={'auto'}>
      <SimpleGrid columns={{ base: 1, md: 4 }} gap={{ base: '5', md: '6' }}>
        {stats.map((stat, id) => (
          <Stat key={id} {...stat} />
        ))}
      </SimpleGrid>
    </Container>
  </Box>
)